import React from 'react';
import { RunState } from '../../api';

interface Props {
  value: RunState;
}

const RunStatusValue: React.FunctionComponent<Props> = props => {
  return <div>{props.value}</div>;
};

export default RunStatusValue;
